module.exports = __webpack_public_path__ + "img/rsa_portal.62a67b6c.png";